import React, { useEffect } from 'react'
import MediaQuery from 'react-responsive'

import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components'
import { useAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'

import { PortfolioRiskLevel } from 'generated/types'
import theme from 'theme'

import usePortfolioData from '../hooks/usePortfolioData'
import { CryptoInterstitalProps } from './CryptoInterstitial'
import { CryptoLanderDesktop } from './CryptoLanderDesktop'
import { CryptoLanderMobile } from './CryptoLanderMobile'
import { BitcoinLanderViewed } from './events'

export const CryptoLander: React.FC<CryptoInterstitalProps> = (props) => {
  const analytics = useAnalyticsClient()
  const { getRemoteString } = useRemoteStrings()
  const { portfolioDetails, isLoadingData } = usePortfolioData()

  const getAllocationPercent = () => {
    const riskLevel = portfolioDetails?.currentRiskPortfolioData.riskLevel
    let etfAllocationPercent = ''
    switch (riskLevel) {
      case PortfolioRiskLevel.Conservative:
        etfAllocationPercent = '1'
        break
      case PortfolioRiskLevel.ModeratelyConservative:
        etfAllocationPercent = '2'
        break
      case PortfolioRiskLevel.Moderate:
        etfAllocationPercent = '3'
        break
      case PortfolioRiskLevel.ModeratelyAggressive:
        etfAllocationPercent = '4'
        break
      case PortfolioRiskLevel.Aggressive:
        etfAllocationPercent = '5'
    }
    return etfAllocationPercent
  }

  useEffect(() => {
    analytics.track(
      'Screen Viewed',
      BitcoinLanderViewed(props.currentProductPortfolio.toLowerCase()),
    )
  }, [])

  return (
    <>
      {!isLoadingData && (
        <>
          <MediaQuery minWidth={theme.breakpoints.sm + 1}>
            <CryptoLanderDesktop {...props} />
          </MediaQuery>
          <MediaQuery maxWidth={theme.breakpoints.sm}>
            <CryptoLanderMobile {...props} />
          </MediaQuery>
          <ConfirmationModal
            isOpen={props.isModalOpen}
            message={getRemoteString({
              key: 'invest.new_etf.lander.alert.add_to_portfolio.body.variable1',
              variables: [getAllocationPercent()],
            })}
            title={props['alert.add_to_portfolio.title']}
            onRequestClose={props.toggleModal}
            actions={[
              {
                label: props['alert.add_to_portfolio.cta.cancel'],
                type: ModalActionTypes.secondary,
                handler: props.toggleModal,
              },
              {
                label: props['alert.add_to_portfolio.cta.confirm'],
                type: ModalActionTypes.primary,
                handler: props.onAddPortfolioConfirmPress,
              },
            ]}
          />
        </>
      )}
    </>
  )
}
